var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatering(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.25 0a1 1 0 00-1 1v5a1.993 1.993 0 01-.571 1.4.251.251 0 01-.429-.175V1a1 1 0 00-2 0v6.223a.251.251 0 01-.429.175A1.993 1.993 0 015.25 6V1a1 1 0 00-2 0v5a4.009 4.009 0 002.667 3.772.5.5 0 01.333.471V23a1 1 0 002 0V10.243a.5.5 0 01.333-.471A4.009 4.009 0 0011.25 6V1a1 1 0 00-1-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.75 0a4 4 0 00-4 4v2a4.009 4.009 0 002.667 3.772.5.5 0 01.333.471V23a1 1 0 002 0V10.243a.5.5 0 01.333-.471A4.009 4.009 0 0020.75 6V4a4 4 0 00-4-4zm-.5 2.5a1 1 0 00-1 1 .5.5 0 01-1 0 2 2 0 012-2 .5.5 0 010 1z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatering);
export default __webpack_public_path__ + "static/media/catering.522902b3.svg";
export { ForwardRef as ReactComponent };